export default __webpack_public_path__ + "static/media/react-logo.9ddae319.png";